import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './icon-arrow-down-black.png'


const _withScopeId = n => (_pushScopeId("data-v-efedc78e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intl-tel-input allow-dropdown" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "country-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flag-box" }
const _hoisted_6 = { class: "country-name" }
const _hoisted_7 = { class: "dial-code" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "divider" }, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flag-box" }
const _hoisted_11 = { class: "country-name" }
const _hoisted_12 = { class: "dial-code" }

import _ from 'lodash';
  import { ref, computed, onMounted, watchEffect } from 'vue';
  import countries, { Country } from './countries';
  import i18n from '@/i18n';
  import './country.css';

  interface IProps {
    countryCodes: Array<string>;
    countryCode: string;
    disabled: boolean;
  }

  interface IEmits {
    (event: 'excountry', country: Country): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    countryCodes: { default: () => ['ko', 'ja', 'au', 'nz'] },
    countryCode: { default: i18n.global.locale.value },
    disabled: { type: Boolean, default: false }
  },
  emits: ["excountry"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'excountry', country: Country): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { countryCodes: Array<string>, countryCode: string, disabled: boolean }

  

  

  const currentCode = ref(props.countryCode);
  const hideSubMenu = ref(true);

  const currentData = computed(() => {
    return countries[currentCode.value] || {};
  });

  const frontCountriesCollection = computed(() => {
    return _.pick(countries, props.countryCodes);
  });

  const countriesCollection = computed(() => {
    return _.omit(countries, props.countryCodes);
  });

  onMounted(() => {
    emits('excountry', countries[currentCode.value]);
  });

  const setCountry = (item: Country) => {
    currentCode.value = item.code;
    emits('excountry', item);
  };

  const handleSelect = (item: Country) => {
    currentCode.value = item.code;
    setCountry(item);
    hideSubMenu.value = true;
  };

  watchEffect(() => {
    setCountry(countries[props.countryCode] || countries['ko']);
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "mask",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSubMenu.value = true))
    }, null, 512), [
      [_vShow, !hideSubMenu.value]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flag-container", { disabled: __props.disabled }])
    }, [
      _createElementVNode("div", {
        class: "selected-flag",
        title: _unref(currentData).name + ': +' + _unref(currentData).dialCode,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (hideSubMenu.value = !hideSubMenu.value))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass('iti-flag ' + _unref(currentData).code)
        }, null, 2),
        (!__props.disabled)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_0,
              class: _normalizeClass(["arrow-icon", hideSubMenu.value ? '' : 'rotate-arrow' ])
            }, null, 2))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      _withDirectives(_createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(frontCountriesCollection), (item, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
            item
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass('country ' + (item.code == currentCode.value ? 'highlight' : '')),
                  onClick: ($event: any) => (handleSelect(item))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass('iti-flag ' + item.code)
                    }, null, 2)
                  ]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1),
                  _createElementVNode("span", _hoisted_7, "+" + _toDisplayString(item.dialCode), 1)
                ], 10, _hoisted_4))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _hoisted_8,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countriesCollection), (item, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
            item
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass('country ' + (item.code == currentCode.value ? 'highlight' : '')),
                  onClick: ($event: any) => (handleSelect(item))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass('iti-flag ' + item.code)
                    }, null, 2)
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1),
                  _createElementVNode("span", _hoisted_12, "+" + _toDisplayString(item.dialCode), 1)
                ], 10, _hoisted_9))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 512), [
        [_vShow, !hideSubMenu.value]
      ])
    ], 2)
  ]))
}
}

})